export default "icons/eye-off.svg"